import { render, staticRenderFns } from "./dubanRiskDialog.vue?vue&type=template&id=f52cbac6&scoped=true"
import script from "./dubanRiskDialog.vue?vue&type=script&lang=js"
export * from "./dubanRiskDialog.vue?vue&type=script&lang=js"
import style0 from "./dubanRiskDialog.vue?vue&type=style&index=0&id=f52cbac6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f52cbac6",
  null
  
)

export default component.exports